<template>
  <div class="aboutUs">
    <section class="main_section">
      <div class="page-contentbox">
        <a @click="goBack" class="back-link">
          <i class="material-icons">arrow_back_ios</i> Back
        </a>
        <h2>Rovi91 Innovations Pvt Ltd</h2>
        <p>आपके अपने शहर की दुकान अब आपके मोबाइल पर - भारत में सबसे अच्छा और सबसे सस्ता सामान - जिसे आप खरीदे बिना रह ना पाएंगे !</p>
        <p>★ यूनीक प्रोडक्ट्स - ऐसे जो आपको ढूंढ़ने पर भी नहीं मिलेंगे अपने शहर में - और ऐसी कीमतों पर जो आपके होश उड़ा देंगी</p>
        <p>★ प्रोडक्ट्स के लाइव शो देखें- रोज़ हमारे स्मार्ट होस्ट्स के साथ - बिलकुल टीवी जैसा - प्रोडक्ट के बारे में समझें - साथ देखने वालों के साथ कमैंट्स से चैट करें</p>
        <p>★ व्हाट्सऐप पर आसानी से आर्डर करें १ क्लिक में- अपना नाम पता व्हाट्सऐप पर लिखें या वौइस् मैसेज में बोलें</p>
        <p>★ व्हाट्सऐप में ही पे करें - कई सारे तरीके - व्हाट्सऐप पे, या पेटीएम, या गूगल पे, या भीम यूपीआई, या डेबिट कार्ड १ पेमेंट लिंक के ज़रिये</p>
        <p>★ या कैश से पे करें - अपने शहर के मॉल91 सेण्टर में आर्डर बुक करने के लिए - और वहीं से अपना आर्डर पिक करें - सिर्फ चुनिंदा शहरों में उपलब्ध (और आ रहा है सब शहरों में जल्द ही)</p>
        <p>★ प्रीपेड ऑर्डर्स को पाएं अपने घर पर ही, कैश पेमेंट ऑर्डर्स को पाएं अपने शहर के मॉल91 सेण्टर से</p>
        <p>★ कमाएं हर दोस्त की खरीद पर कैश - बस अपने दोस्तों के साथ व्हाट्सऐप पर प्रोडक्ट्स के लिंक शेयर करें - हर दोस्त की खरीद पर पाएं कैश - और दोस्तों के आगे शेयर करने पर उनकी कमाई का १ हिस्सा भी आपको मिलेगा !</p>
        <p>4MB से भी कम साइज की ऐप</p>
        <p>हमारे व्हाट्सऐप समूह को ज्वाइन करें और रोज़ पाएं १ नयी धमाकेदार डील - जो आपको पूरे भारत में कहीं नहीं मिलेगी - दोस्तों से भी व्हाट्सऐप समूह का लिंक शेयर करें क्योंकि दोस्तों के साथ डील खरीदने में आपको मिलेगा और भारी डिस्काउंट!</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
